import { Injectable } from "@angular/core";
import { ToasterService } from "./toaster.service";
import { DeterminantDetails } from "../models/determinant-details";
import { DeterminantType } from "../constants/finance-constants";
import { firstValueFrom } from "rxjs";
import { FinanceApiService } from "./finance-a-p-iervice.service";

@Injectable({
    providedIn: 'root'
  })
  export class FinanceService {

    constructor(private financeApiService: FinanceApiService,
        private toasterService: ToasterService
    ) { 

    }

    async getDeterminants(determinantType: DeterminantType, chargeId ?: string | {key: 'string'}): Promise<DeterminantDetails[]> {
        try {
            const res = await firstValueFrom(this.financeApiService.getDeterminantDetails(determinantType, chargeId));
            return res.data;
        } catch (error) {
            console.error('File upload failed:', error);
            this.toasterService.error("Failed to fetch determinants");
            throw error;
        }
    } 
}